import {
    UPDATEUSERADDR_REQUEST,
    UPDATEUSERADDR_SUCCESS,
    UPDATEUSERADDR_FAILURE,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    updateUserAddrStatus: [],
    error: null,
};

export default function updateUserAddrReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATEUSERADDR_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case UPDATEUSERADDR_SUCCESS:
            return {
                ...state,
                // always replacing data
                updateUserAddrStatus: action.data,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case UPDATEUSERADDR_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
